var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,{tag:"component",staticClass:"house-notes-logo"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.svg)}}),_vm._v(" "),_c('span',[_vm._v("House Notes")])])}
var staticRenderFns = []

export { render, staticRenderFns }